<template>
    <div>        
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/freight/management/edit')" type="primary" icon="el-icon-set-up" size="small" @click="add()">新增运费模板</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
				
                <el-table-column prop="name" label="模板名称" min-width="120"></el-table-column>
                <el-table-column prop="freightView" label="运费" show-overflow-tooltip min-width="150"></el-table-column>				
                <el-table-column prop="bindCount" label="绑定商品数" show-overflow-tooltip min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" >
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/freight/management/edit')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row)"
                            >编辑</el-button>                                              
                        <el-button
                            v-if="$utils.have('/freight/management/delete')"
                            type="text"
                            size="small"
                            icon="el-icon-delete"
							 @click="del(scope.row.id,scope.row.onSaleCount)"
                            >删除</el-button>
                    </template>    
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
		<Edit ref="Edit"  @onUpdate="getDataList" ></Edit>        
    </div>
</template>

<script>
import Edit from './components/edit';
const defaultParams = {
    pageNo:1,
    
}
export default {
    components:{Edit},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0])                
            },
            
            listLoading: true,            
            downLoading: false
        }
    },
    computed:{
        
    },
    mounted() {
		
        this.getDataList();
    },
    methods:{
		
        //获取列表
        getDataList() {
			
            this.listLoading = true;
            this.params = {
                ...this.params			
            }
            this.$request({
                url: "/freight/management/pageList",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                        
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },	   
	   add(){		   
		   this.$refs.Edit.show();
	   },
	   //编辑事件
	   edit(row) {
	       this.$refs.Edit.show(row);
	   },
	   //删除
	   del(id,num){
		   if( num > 0 ){
			   this.$message.error("当前模板还有商品正在使用，无法删除！");
			   return
		   }else{
			   this.$confirm('确认删除该运费模板？', '提示', {
			       type: 'success',
			       center: true,
			       confirmButtonText:'确认删除',
			       cancelButtonText:'暂不删除',
			       closeOnClickModal: false
			   }).then(() => {
			      this.$request({
			          url: "/freight/management/delete",
			          method: "POST",
			          params: {id:id},
			      })
			          .then((res) => {
			              const { state, msg } = res.data;
			              if (state == 1) {
			                  this.$message.success('删除成功');
			                  this.getDataList();
			              } else {
			                  this.$message.error(msg || "请求失败");
			              }
			          })
			          .catch(() => {
			              this.$message.error("请求错误");
			          })
				  
				  
			   }).catch(() => {
			       
			   })
		   }
		   
	   }
    }
}
</script>